<div class="aa-header">
  <pt-logo/>
  <div class="aa-header__right">
    <aa-header-user-profile/>
    <aa-header-controls/>
  </div>
</div>
